import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const DesignedBy = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allOptionList, setAllOptionList] = useState([]);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allOptionList);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.COSTING_LIST]: dependentFilterList?.designByList,
		[allFilterPages.SALES_FUNNEL_LIST]: dependentFilterList?.designByList,
		[allFilterPages.SAMPLE_LIST]: dependentFilterList?.designByList
	};

	const onFetchData = () => {
		let responseData = filterData[filterPageName];
		if (filterPageName === allFilterPages.SALES_FUNNEL_LIST) {
			responseData = dependentFilterList?.designedByList?.map((item) => ({
				id: item.isNitexDesign ? 1 : 2,
				name: item.isNitexDesign ? 'Nitex Design' : 'Buyer Design'
			}));
		} else {
			responseData = responseData?.map((item) => {
				return { id: item.constant, name: item.name, count: item?.count };
			});
		}
		setAllOptionList(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allOptionList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: allOptionList;
		setData(searchResult);
	};

	return (
		<>
			<FilterName type="DESIGNED_BY" />
			<Checkbox type="DESIGNED_BY" data={data} handleSearch={handleSearch} />
		</>
	);
};

export default DesignedBy;
